import { Component, OnInit } from '@angular/core';
import { Globals } from '@myApp/globals.ts';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {

  public isMobile: Boolean;
  public carouselInputs;

    constructor(private globals: Globals) {
  }

  ngOnInit() {
    this.onResize();
    this.year();
    this.initCarousel();
  }
  onResize() {
      // this.globals.checkWidth();

      this.globals.getMobileStatus().subscribe(isMobile => {
      this.isMobile = isMobile;
    });
  }
  year() {
    return new Date().getFullYear();
  }

    private initCarousel() {
        this.carouselInputs = {
            grid: { xs: 3, sm: 3, md: 3, lg: 3, all: 0 },
            slide: 1,
            speed: 400,
            interval: 4000,
            point: {
                visible: true
            },
            load: 2,
            touch: true,
            loop: true,
            custom: 'banner'
        };
    }


}








// WEBPACK FOOTER //
// C:/Users/beyn/Documents/GitLab/spinmatic-casino/src/app/Modules/Shared/components/footer/footer.component.ts